import { Button } from '@/components/atoms/Button';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LegendButtonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$embedMode',
})<{ $embedMode?: boolean }>(({ theme, $embedMode }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(0.5),
  ...($embedMode && {
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
  }),
}));

interface StyledLegendButtonProps {
  noBorderBottom: boolean;
}

export const StyledLegendButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'noBorderBottom',
})<StyledLegendButtonProps>(({ theme, noBorderBottom }) => ({
  width: 40,
  height: 40,
  borderRadius: '4px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(1),
  '&:hover': {
    backgroundColor: theme.palette.common.white,
    filter: 'brightness(0.8)',
  },
  ...(noBorderBottom && {
    borderBottom: `0.5px solid ${theme.palette.divider}`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  }),
}));

export const MenuHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    '> button': {
      padding: theme.spacing(0),
    },
  },
}));

export const MobileLegend = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 56,
  right: 0,
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '256px',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  pointerEvents: 'auto',
}));
